import script from "./ProductFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFormModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductFormModal.vue?vue&type=style&index=0&id=ea25379a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea25379a"]])

export default __exports__